import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { ReactComponent as FixtabLogo } from 'assets/svg/fixtab-logo-with-text.svg'
import { Loader } from 'components'
import { exchangeToken } from 'helpers/exchangeToken'

const LoginContainer: React.VFC = () => {
  const { t } = useTranslation('login')

  useEffect(() => {
    exchangeToken()
  }, [])

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '16px',
        backgroundColor: '#ffffff',
      }}
      data-testid='login-loading'
      role='status'
      aria-busy='true'
      aria-live='polite'
    >
      <FixtabLogo style={{ width: '160px', marginBottom: '8px' }} />
      <Loader size='lg' />
      <p style={{ margin: 0, fontSize: '16px', color: '#333333' }}>
        {t('loading.title')}
      </p>
    </div>
  )
}

export default LoginContainer
